import { useEffect, useState } from 'react';

import Axios from 'axios';

import { useContactPicturesAndVideos } from '@hooks/API/Contact/UseContactMedia';

import { usePlaylistEditor, usePlaylistEditorDispatch } from './PlaylistEditorContext';
import { bookInit } from './PlaylistEditorUtils';

/**
 * Carica il book da modificare e l'archivio media della modella, riempiendo il
 * context dell'editor.
 *
 * Condiviso tra editor desktop e mobile: l'ordine delle dispatch conta, perche'
 * `ToggleSinglePage` rimpagina la lista appena impostata da `SetPlaylistItems`.
 */
const usePlaylistEditorData = () => {
    const { bookToEdit, mediaTypeToDisplay, packageID, selectedModel } = usePlaylistEditor();
    const dispatch = usePlaylistEditorDispatch();

    const [book, setBook] = useState(null);
    const [isFetchingBook, setIsFetchingBook] = useState(false);

    const { data: documents, isFetching: isFetchingDocuments } = useContactPicturesAndVideos(selectedModel);

    useEffect(() => {
        const endpoint = packageID ? 'packageplaylists' : 'playlists';
        setIsFetchingBook(true);
        Axios.get(`/${endpoint}/${bookToEdit}`)
            .then((res) => {
                setBook(res);
                setIsFetchingBook(false);
            })
            .catch((err) => {
                console.error(err);
                setIsFetchingBook(false);
            });
    }, [bookToEdit, packageID]);

    useEffect(() => {
        if (isFetchingDocuments || !documents || documents.length === 0) {
            dispatch({ type: 'SetIsFetchingDocuments', value: true });
            dispatch({ type: 'SetActiveId', value: null });
            dispatch({ type: 'SetActiveItem', value: null });
            dispatch({ type: 'FillDocumentsList', value: [] });
        } else {
            dispatch({ type: 'SetIsFetchingDocuments', value: false });
            const filteredDocuments = documents
                .filter((document) => document.Type === mediaTypeToDisplay)
                .sort((a, b) => b.ID - a.ID)
                .map((document, index) => ({
                    ...document,
                    position: index,
                }));
            dispatch({ type: 'FillDocumentsList', value: filteredDocuments });
        }
    }, [documents, mediaTypeToDisplay, isFetchingDocuments]);

    useEffect(() => {
        if (book) {
            dispatch({ type: 'SetPlaylistItems', value: bookInit(book) });
            dispatch({ type: 'BookToEditData', value: book });
            dispatch({
                type: 'ToggleSinglePage',
                value: book.Layout === 'Sequence',
            });
        }
    }, [book]);

    return { isFetchingBook };
};

export default usePlaylistEditorData;
